import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  countries_code,
  education_category,
  healthProviders,
} from "../../utilis/constants";
import { eduStatus, note_type } from "../../utilis/appStatus";
import Multiselect from "multiselect-react-dropdown";
import {
  CloudUpload,
  DollarSign,
  FileText,
  Paperclip,
  StickyNote,
  X,
} from "lucide-react";
import "./cms-add-note-modal.css";
import { getLocalDateInputValue } from "../../utilis/followupConstants";

const APPROVAL_FILE_ACCEPT =
  ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png";

class Modals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassError: "",
      newPassError: "",
      confirmNewPassError: "",
      show: false,
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      name: "",
      email: "",
      processingTasks: false,
      processingDueDate: "",
      processingPriority: "Standard",
      mobile: "",
      country: "",
      type: "",
      confirmNewPass: "",
      oldPass: "",
      newPass: "",
      checkbox: false,
      checkbox2: false,
      courses: [],
      selectedFile: "",
      selectedFile1: "",
      selectedFile2: "",
      healthClaim: "",
      addMore: "false",
      ceoFiles: [{ file: "", error_file: "" }],
      paymentFiles: [{ file: "", error_file: "" }],
      oshcRecipt: "",
      oshcCertificate: "",
      provider: "",
      groups: [],
      tags: [],
      refundError: false,
      approvalFiles: [{ file: "", error_file: "" }],
      statusChangeDate: "",
      oshc_user_confirmed: false,
      intake_id: "",
      intakeError: "",
      isFinanceNote: false,
      isDragOver: false,
      uploadZoneDragOver: null,
    };
    this.approvalFileInputRefs = [];
    this.paymentFileInputRefs = [];
    this.coeFileInputRefs = [];
    this.approvalBulkInputRef = null;
    this.paymentBulkInputRef = null;
    this.coeBulkInputRef = null;
    this.approvalDragCounter = 0;
    this.handleChange = this.handleChange.bind(this);
    this.handleGroupChange = this.handleGroupChange.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleProceed = this.handleProceed.bind(this);
    this.handleTeamSubmit = this.handleTeamSubmit.bind(this);
    this.handlePassSubmit = this.handlePassSubmit.bind(this);
    this.handleAssignUserSubmit = this.handleAssignUserSubmit.bind(this);
    this.handleApprovalSubmit = this.handleApprovalSubmit.bind(this);
    this.handleEduApprovalSubmit = this.handleEduApprovalSubmit.bind(this);
  }
  componentDidMount() {
    if (this.props.healthRefund) {
      this.setState({ healthClaim: "1", oshc_user_confirmed: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.healthRefund && !prevProps.healthRefund) {
      this.setState({ healthClaim: "1", oshc_user_confirmed: true });
    }
    if (this.props.show && !prevProps.show && this.props.healthRefund) {
      this.setState({ healthClaim: "1", oshc_user_confirmed: true });
    }
    if (
      this.props.show &&
      !prevProps.show &&
      this.props.courses?.length
    ) {
      this.setState({
        courses: this.props.courses.map((c) => ({ ...c })),
      });
    }
    if (this.props.show && !prevProps.show && this.props.invoiceFollowupComplete) {
      this.setState({
        checkbox: false,
        checkbox2: false,
        mobile: getLocalDateInputValue(),
        name: "",
        email: "",
        country: "",
      });
    }
  }

  getCourseRowsForSubmit = () => {
    if (this.state.courses?.length > 0) {
      return this.state.courses;
    }
    return this.props.courses || [];
  };

  hasFinanceNotePermission = () => {
    try {
      const permissions = getPermissions() || {};
      return (
        permissions["finance_notes"] === 1 ||
        permissions["finance_notes"] === "1"
      );
    } catch (e) {
      return false;
    }
  };

  isClientNoteModal = () =>
    this.props.type === "category" &&
    this.props.clientNote &&
    this.props.textarea &&
    !this.props.date;

  handleModal() {
    // this.setState({
    //   checkbox: false,
    //   checkbox2: false,
    //   healthClaim: "",
    //   bonusList: [
    //     {
    //       startdate: "",
    //       enddate: "",
    //       bonus: "",
    //       startdate_error: "",
    //       enddate_error: "",
    //       bonus_error: "",
    //     },
    //   ],
    // });
    // this.props.parentCallback(this.props.show, false);
    this.resetNoteForm();
    this.props.parentCallback(this.props.show, false);
  }

  resetNoteForm = () => {
    this.approvalDragCounter = 0;
    this.approvalFileInputRefs = [];
    this.paymentFileInputRefs = [];
    this.coeFileInputRefs = [];
    this.setState({
      name: "", // Note text
      email: "", // Medium dropdown
      mobile: false, // Client portal checkbox
      country: "", // Country (if used)
      checkbox: false, // RFI checkbox
      processingTasks: false, // Tasks checkbox
      processingDueDate: "", // Due date
      processingPriority: "Standard", // Priority dropdown
      approvalFiles: [{ file: "", error_file: "" }], // Reset file uploads
      ceoFiles: [{ file: "", error_file: "" }],
      paymentFiles: [{ file: "", error_file: "" }],
      // healthClaim: "", // OSHC radio
      healthClaim: this.props.healthRefund ? "1" : "", // Auto-set to "1" if prop is true
      provider: "", // Provider dropdown
      oshcRecipt: "", // OSHC receipt
      oshcCertificate: "", // OSHC certificate
      courses: [], // Courses (if used)
      statusChangeDate: "",
      submitted: false,
      oshc_user_confirmed: this.props.healthRefund ? true : false,
      isDragOver: false,
      uploadZoneDragOver: null,
      intake_id: "",
      intakeError: "",
      isFinanceNote: false,
    });
  };

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleGroupChange(event) {
    const selectedGroupId = event.target.value;
    const { data, data1 } = this.props;

    const record = data.find((element) => {
      return element.id == selectedGroupId;
    });

    if (record) {
      const usingSplit = record.users.split(",");
      const options = usingSplit.map((intake) => {
        const name = data1.find((element) => {
          if (element.value == intake) {
            const newName = { label: element.label, value: element.value };
            console.log(newName);
            return newName; // Add a return statement here
          }
        });

        // Return null or undefined if the condition is not met
        return name;
      });

      // Remove the commented-out code and update the state
      this.setState({
        tags: options.filter(Boolean), // Remove null or undefined values
        [event.target.name]: event.target.value,
      });
    } else {
      this.setState({ tags: [], [event.target.name]: event.target.value });
    }
  }

  handleOptionChange(e) {
    this.setState({
      [e.target.name]: e.target.options[e.target.selectedIndex].text,
    });
  }
  // migration applications
  handleApprovalSubmit() {
    // this.setState({addMore: false, approvalFiles:[]});
    const list = [...this.state.approvalFiles];
    if (!list[0]["file"]) {
      list[0]["error_file"] = "Please upload approval file";
      this.setState({ approvalFiles: list });
    } else {
      list[0]["error_file"] = "";
      this.setState({ approvalFiles: list });
      this.props.parentCallback(
        this.props.show,
        "edit",
        this.state.name,
        this.state.approvalFiles,
        this.state.processingPriority,
        this.state.processingDueDate,
        this.state.processingTasks,
        this.state.statusChangeDate,
      );
      this.resetNoteForm();
    }
  }
  //edu inner aplication add note not triggering from here
  handleEduApprovalSubmit() {
    console.log("inisde handleEDU APPROVAL submit");
    // this.setState({addMore: false, approvalFiles:[]});
    const list = [...this.state.approvalFiles];
    if (!list[0]["file"]) {
      list[0]["error_file"] = "Please upload approval file";
      this.setState({ approvalFiles: list });
    } else {
      list[0]["error_file"] = "";
      this.props.parentCallback(
        this.props.show,
        "edit",
        this.state.name,
        this.state.email,
        this.state.mobile,
        this.state.country,
        this.getCourseRowsForSubmit(),
          this.state.approvalFiles,
        this.state.paymentFiles,
        this.state.ceoFiles,
        this.state.healthClaim,
        this.state.oshcRecipt,
        this.state.oshcCertificate,
        this.state.provider,
        this.state.statusChangeDate,
        this.state.oshc_user_confirmed,
      );
      this.resetNoteForm();
      this.setState({
        approvalFiles: list,
        addMore: false,
        ceoFiles: [],
        checkbox: false,
        checkbox2: false,
        healthClaim: "",
      });
    }
  }

  handleSubmit() {
    if (
      this.props.from === "edu" &&
      (this.props.appid === 110 || this.props.appid === "110") &&
      !this.state.intake_id
    ) {
      this.setState({
        intakeError: "Please select new intake",
        submitted: true,
      });
      return false;
    }
    this.setState({ intakeError: "" });
    console.log(
      "in modal 160/",
      this.state.processingDueDate,
      this.state.processingPriority,
    );
    if (this.props.showStatusDate) {
      if (!this.state.statusChangeDate.trim()) {
        this.setState({ submitted: true });
        return false;
      }
    }
    if (
      (this.props.appid === 9 || this.props.appid === "9") &&
      this.props.from === "mig"
    ) {
      console.log(
        "164 if --- in modal 160/",
        this.state.processingDueDate,
        this.state.processingPriority,
      );

      this.props.parentCallback(
        this.props.show,
        "edit",
        this.state.name,
        this.state.checkbox,
        this.state.email,
        this.state.checkbox2,
        this.state.mobile,
        this.state.processingTasks,
        this.state.processingDueDate,
        this.state.processingPriority,
        this.state.intake_id,
      );
    } else if (this.props.appid === 10 || this.props.appid === "10") {
      console.log(
        "179 elseif --- in modal 160/",
        this.state.processingDueDate,
        this.state.processingPriority,
      );
      this.props.parentCallback(
        this.props.show,
        "edit",
        this.state.name,
        this.state.checkbox,
        this.state.checkbox2,
        this.state.intake_id,
      );
    } else {
      // this is adding note in edu inner applications if-case
      console.log(
        "182 else --- in modal 160/",
        this.state.processingDueDate,
        this.state.processingPriority,
      );
      if (this.state.processingTasks === true) {
        console.log(
          "184 if --- in modal 160/",
          this.state.processingDueDate,
          this.state.processingPriority,
        );

        this.props.parentCallback(
          this.props.show,
          "edit",
          this.state.name,
          this.state.email,
          this.state.processingPriority,
          this.state.processingDueDate,
          this.state.processingTasks,
          this.state.intake_id,
          this.state.isFinanceNote,
        );
      } else {
        console.log(
          "199 else --- in modal 160/",
          this.state.processingDueDate,
          this.state.processingPriority,
        );
        if (this.props.invoiceFollowupComplete) {
          this.props.parentCallback(
            this.props.show,
            "edit",
            this.state.name,
            this.state.email,
            this.state.checkbox === true ? this.state.mobile : false,
            this.state.checkbox2 === true ? this.state.country : false,
          );
          this.setState({
            addMore: false,
            ceoFiles: [],
            paymentFiles: [],
            checkbox: false,
            checkbox2: false,
            healthClaim: "",
          });
          this.resetNoteForm();
          return;
        }
        this.props.parentCallback(
          this.props.show,
          "edit",
          this.state.name,
          this.state.email,
          this.state.mobile,
          this.state.country,
          this.getCourseRowsForSubmit(),
          this.state.selectedFile[0]
            ? this.state.selectedFile
            : this.state.approvalFiles,
          this.state.isFinanceNote,
          this.props.appid === 9 || this.props.appid === "9"
            ? this.state.ceoFiles
            : this.state.paymentFiles,
          this.state.ceoFiles[0]?.file
            ? this.state.ceoFiles
            : this.state.paymentFiles,
          this.state.healthClaim,
          this.state.oshcRecipt,
          this.state.oshcCertificate,
          this.state.provider,
          this.state.statusChangeDate,
          this.state.oshc_user_confirmed,
          this.state.intake_id,
        );
      }
    }
    this.setState({
      addMore: false,
      ceoFiles: [],
      paymentFiles: [],
      checkbox: false,
      checkbox2: false,
      healthClaim: "",
    });
    this.resetNoteForm();
  }

  handlePassSubmit() {
    this.setState({
      oldPassError: null,
      newPassError: null,
      confirmNewPassError: null,
    });
    if (!this.state.oldPass) {
      this.setState({ oldPassError: "Please enter old password" });
      return false;
    } else if (!this.state.newPass) {
      this.setState({ newPassError: "Please enter new password" });
      return false;
    } else if (this.state.confirmNewPass !== this.state.newPass) {
      this.setState({ confirmNewPassError: "Password do not match" });
      return false;
    } else {
      this.props.parentCallback(
        this.props.show,
        "pass",
        this.state.oldPass,
        this.state.newPass,
        this.state.confirmNewPass,
        null,
      );
    }
  }
  handleAssignUserSubmit() {
    this.setState({ tags: [] });
    this.props.parentCallback(
      this.props.show,
      "edit",
      this.state.value1,
      this.state.groups,
    );
  }
  handleTeamSubmit() {
    console.log("insideTeam Submit");
    this.setState({
      name: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
    });
    this.props.parentCallback(
      this.props.show,
      this.props.type,
      this.state.name,
      this.state.value1,
      this.state.value2,
      this.state.value3,
      this.state.value4,
      this.state.value5,
      this.state.value6,
      this.state.value7,
      this.props.data,
    );
  }
  handleProceed() {
    this.setState({ value1: "", value2: "" });
    this.props.parentCallback(
      this.props.show,
      "edit",
      this.state.value1,
      this.state.value2,
    );
  }
  // handle input change
  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const base =
      this.state.courses?.length > 0
        ? this.state.courses
        : (this.props.courses || []).map((c) => ({ ...c }));
    const list = base.map((item, i) =>
      i === index ? { ...item, [name]: value } : item,
    );
    this.setState({ courses: list });
  };
  fileSelectedHandler = (event) => {
    this.setState({ selectedFile: event.target.files[0] });
  };
  fileSelectedHandlerOshc = (event) => {
    this.setState({ oshcRecipt: event.target.files[0] });
  };
  fileSelectedHandlerOshcCertificate = (event) => {
    this.setState({ oshcCertificate: event.target.files[0] });
  };
  fileSelectedHandler1 = (event) => {
    console.log("dd");
    this.setState({ selectedFile1: event.target.files[0] });
  };
  fileSelectedHandler2(e, index) {
    console.log("dd");
    e.preventDefault();
    const list = [...this.state.ceoFiles];
    list[index]["file"] = e.target.files[0];
    this.setState({ ceoFiles: list });
  }
  fileSelectedHandler3(e, index) {
    console.log(index);
    e.preventDefault();
    const list = [...this.state.paymentFiles];
    list[index]["file"] = e.target.files[0];
    this.setState({ paymentFiles: list });
  }
  addMore = (e) => {
    e.preventDefault();
    this.setState({ ceoFiles: [...this.state.ceoFiles, { file: "" }] });
  };
  addMorePayment = (e) => {
    e.preventDefault();
    this.setState({ paymentFiles: [...this.state.paymentFiles, { file: "" }] });
  };
  // handle click event of the Remove button
  handleRemoveClick = (index, e) => {
    e.preventDefault();
    this.removeFileFromStateList("ceoFiles", index, this.coeFileInputRefs);
  };
  handleRemoveClickPayment = (index, e) => {
    e.preventDefault();
    this.removeFileFromStateList(
      "paymentFiles",
      index,
      this.paymentFileInputRefs,
    );
  };

  onUsersSelect = (selectedList) => {
    this.setState({ groups: selectedList });
  };
  onUsersRemove = (selectedList) => {
    this.setState({ groups: selectedList });
  };

  handleAddClick(e, index) {
    e.preventDefault();
    console.log("index", index);
    const list = [...this.state.approvalFiles];
    if (!list[index]["file"]) {
      list[index]["error_file"] = "Please upload file first!";
      this.setState({ approvalFiles: list });
    } else {
      list[index]["error_file"] = "";
      this.setState({
        approvalFiles: [
          ...this.state.approvalFiles,
          { file: "", error_file: "" },
        ],
      });
    }
  }

  handleApprovalRemoveClick(index, e) {
    e.preventDefault();
    this.removeFileFromStateList(
      "approvalFiles",
      index,
      this.approvalFileInputRefs,
    );
  }
  handleApprovalInputChange(e, index) {
    e.preventDefault();
    const list = [...this.state.approvalFiles];
    list[index]["file"] = e.target.files[0];
    this.setState({ approvalFiles: list });
  }

  supportsApprovalFileDrop = () =>
    this.props.uploadDoc1 === true && this.props.multipleFiles === true;

  handleApprovalDragOver = (e) => {
    if (!this.supportsApprovalFileDrop()) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = "copy";
    }
  };

  handleApprovalDragEnter = (e) => {
    if (!this.supportsApprovalFileDrop()) return;
    e.preventDefault();
    e.stopPropagation();
    this.approvalDragCounter += 1;
    if (this.approvalDragCounter === 1) {
      this.setState({ isDragOver: true });
    }
  };

  handleApprovalDragLeave = (e) => {
    if (!this.supportsApprovalFileDrop()) return;
    e.preventDefault();
    e.stopPropagation();
    this.approvalDragCounter -= 1;
    if (this.approvalDragCounter <= 0) {
      this.approvalDragCounter = 0;
      this.setState({ isDragOver: false });
    }
  };

  addFilesToStateList = (stateKey, files, inputRefs = []) => {
    const droppedFiles = Array.from(files || []).filter((file) => file);
    if (!droppedFiles.length) return;

    const list = [...this.state[stateKey]];
    droppedFiles.forEach((file) => {
      const lastIndex = list.length - 1;
      if (!list[lastIndex]?.file) {
        list[lastIndex] = { ...list[lastIndex], file, error_file: "" };
      } else {
        list.push({ file, error_file: "" });
      }
    });

    this.setState({ [stateKey]: list }, () =>
      this.syncFileInputRefs(inputRefs, list),
    );
  };

  removeFileFromStateList = (stateKey, index, inputRefs = []) => {
    const list = [...this.state[stateKey]];
    list.splice(index, 1);
    if (list.length === 0) {
      list.push({ file: "", error_file: "" });
    }
    this.setState({ [stateKey]: list }, () =>
      this.syncFileInputRefs(inputRefs, list),
    );
  };

  syncFileInputRefs = (inputRefs, files) => {
    files.forEach((item, index) => {
      const input = inputRefs[index];
      if (!input || !item.file) return;
      try {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(item.file);
        input.files = dataTransfer.files;
      } catch (error) {
        // File input sync is best-effort for drag-and-drop previews.
      }
    });
  };

  addApprovalFiles = (files) => {
    this.addFilesToStateList(
      "approvalFiles",
      files,
      this.approvalFileInputRefs,
    );
  };

  addPaymentFiles = (files) => {
    this.addFilesToStateList(
      "paymentFiles",
      files,
      this.paymentFileInputRefs,
    );
  };

  addCoeFiles = (files) => {
    this.addFilesToStateList("ceoFiles", files, this.coeFileInputRefs);
  };

  handleApprovalFileDrop = (e) => {
    if (!this.supportsApprovalFileDrop()) return;
    e.preventDefault();
    e.stopPropagation();
    this.approvalDragCounter = 0;
    this.setState({ isDragOver: false, uploadZoneDragOver: null });
    this.addApprovalFiles(e.dataTransfer?.files);
  };

  handleUploadZoneDrop = (stateKey, inputRefs, e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ uploadZoneDragOver: null });
    const addHandler =
      stateKey === "paymentFiles"
        ? this.addPaymentFiles
        : stateKey === "ceoFiles"
          ? this.addCoeFiles
          : this.addApprovalFiles;
    addHandler(e.dataTransfer?.files);
  };

  handleUploadZoneDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = "copy";
    }
  };

  handleUploadZoneDragEnter = (zoneKey) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ uploadZoneDragOver: zoneKey });
  };

  handleUploadZoneDragLeave = (zoneKey) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.uploadZoneDragOver === zoneKey) {
      this.setState({ uploadZoneDragOver: null });
    }
  };

  handleBulkInputChange = (stateKey, inputRefs, e) => {
    e.preventDefault();
    if (e.target.files?.length) {
      this.addFilesToStateList(stateKey, e.target.files, inputRefs);
    }
    e.target.value = "";
  };

  triggerStateFilePicker = (bulkRef, multiple = true) => {
    if (!bulkRef) return;
    bulkRef.multiple = multiple;
    bulkRef.value = "";
    bulkRef.click();
  };

  triggerApprovalFilePicker = (multiple = true) => {
    this.triggerStateFilePicker(this.approvalBulkInputRef, multiple);
  };

  formatApprovalFileSize = (bytes) => {
    if (!bytes) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  getApprovalFileTypeLabel = (file) => {
    const extension = file?.name?.split(".").pop()?.toUpperCase();
    if (extension) return extension;
    if (file?.type?.includes("pdf")) return "PDF";
    if (file?.type?.startsWith("image/")) return "IMAGE";
    return "FILE";
  };

  renderFileUploadSection({
    label,
    stateKey,
    zoneKey,
    bulkRefSetter,
    getBulkRef,
    inputRefs,
    onRemove,
    useModalDrag = false,
  }) {
    const files = this.state[stateKey] || [];
    const uploadedFiles = files
      .map((item, index) => ({ ...item, index }))
      .filter((item) => item.file);
    const hasUploadedFiles = uploadedFiles.length > 0;
    const slotErrors = files.filter((item) => item.error_file);
    const isDragOver = useModalDrag
      ? this.state.isDragOver
      : this.state.uploadZoneDragOver === zoneKey;

    return (
      <div className="cms-approval-upload-section mt-3">
        <label className="cms-completed-note-label">
          <Paperclip size={14} aria-hidden="true" />
          <span>{label}</span>
        </label>

        <input
          type="file"
          className="d-none"
          ref={bulkRefSetter}
          accept={APPROVAL_FILE_ACCEPT}
          onChange={(e) =>
            this.handleBulkInputChange(stateKey, inputRefs, e)
          }
        />

        {uploadedFiles.map(({ file, index, error_file }) => (
          <div
            key={`${file.name}-${index}`}
            className="cms-approval-file-item"
          >
            <div
              className={`cms-approval-file-icon cms-approval-file-icon--${this.getApprovalFileTypeLabel(file).toLowerCase()}`}
            >
              {this.getApprovalFileTypeLabel(file)}
            </div>
            <div className="cms-approval-file-meta">
              <strong>{file.name}</strong>
              <span>
                {this.formatApprovalFileSize(file.size)} •{" "}
                {this.getApprovalFileTypeLabel(file)}
              </span>
              {error_file ? (
                <small className="error d-block">{error_file}</small>
              ) : null}
            </div>
            <button
              type="button"
              className="cms-approval-file-remove"
              onClick={(e) => onRemove(index, e)}
              aria-label={`Remove ${file.name}`}
            >
              <X size={14} />
            </button>
            <input
              type="file"
              className="d-none"
              ref={(el) => {
                inputRefs[index] = el;
              }}
            />
          </div>
        ))}

        <div
          className={`cms-approval-dropzone${
            !hasUploadedFiles ? " is-empty" : ""
          }${isDragOver ? " is-drag-over" : ""}`}
          onClick={() => this.triggerStateFilePicker(getBulkRef(), true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.currentTarget.click();
            }
          }}
          onDragOver={this.handleUploadZoneDragOver}
          onDragEnter={this.handleUploadZoneDragEnter(zoneKey)}
          onDragLeave={this.handleUploadZoneDragLeave(zoneKey)}
          onDrop={(e) => this.handleUploadZoneDrop(stateKey, inputRefs, e)}
          role="button"
          tabIndex={0}
        >
          <span className="cms-approval-dropzone-icon" aria-hidden="true">
            <CloudUpload size={hasUploadedFiles ? 16 : 22} />
          </span>
          <span className="cms-approval-dropzone-title">
            Drag &amp; drop your file here
          </span>
        </div>

        {slotErrors.map((item, index) =>
          item.error_file ? (
            <small key={`${zoneKey}-error-${index}`} className="error d-block">
              {item.error_file}
            </small>
          ) : null,
        )}
      </div>
    );
  }

  renderApprovalFileUpload() {
    return this.renderFileUploadSection({
      label: this.props.multipleFilesName || "Upload Approval File",
      stateKey: "approvalFiles",
      zoneKey: "approval",
      bulkRefSetter: (el) => {
        this.approvalBulkInputRef = el;
      },
      getBulkRef: () => this.approvalBulkInputRef,
      inputRefs: this.approvalFileInputRefs,
      onRemove: this.handleApprovalRemoveClick.bind(this),
      useModalDrag: true,
    });
  }

  renderPaymentFileUpload() {
    return this.renderFileUploadSection({
      label: "Upload payment Receipt",
      stateKey: "paymentFiles",
      zoneKey: "payment",
      bulkRefSetter: (el) => {
        this.paymentBulkInputRef = el;
      },
      getBulkRef: () => this.paymentBulkInputRef,
      inputRefs: this.paymentFileInputRefs,
      onRemove: this.handleRemoveClickPayment,
    });
  }

  renderCoeFileUpload() {
    const label =
      this.props.file1name === "Upload offer accecptance:"
        ? "Upload offer acceptance"
        : "Upload COE Acceptance";
    return this.renderFileUploadSection({
      label,
      stateKey: "ceoFiles",
      zoneKey: "coe",
      bulkRefSetter: (el) => {
        this.coeBulkInputRef = el;
      },
      getBulkRef: () => this.coeBulkInputRef,
      inputRefs: this.coeFileInputRefs,
      onRemove: this.handleRemoveClick,
    });
  }

  checkRefund(value) {
    this.setState({ refundError: false });
    if (value > this.props.paid) {
      this.setState({ refundError: true });
    }
    this.setState({ name: value });
  }

  render() {
    const isClientNoteModal = this.isClientNoteModal();
    const supportsApprovalFileDrop = this.supportsApprovalFileDrop();
    const usesScrollableUploadModal =
      supportsApprovalFileDrop ||
      this.props.uploadDoc2 === true ||
      this.props.selectedAppId == 9 ||
      this.props.selectedAppId == "9";
    const approvalDropHandlers = supportsApprovalFileDrop
      ? {
          onDragOver: this.handleApprovalDragOver,
          onDragEnter: this.handleApprovalDragEnter,
          onDragLeave: this.handleApprovalDragLeave,
          onDrop: this.handleApprovalFileDrop,
        }
      : {};

    return (
      <>
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.props.show}
          onHide={() => this.handleModal()}
          backdrop="static"
          keyboard={false}
          dialogClassName={[
            isClientNoteModal
              ? "cms-add-note-modal"
              : this.props.dialogClassName || "",
            usesScrollableUploadModal
              ? `cms-multifile-modal${
                  supportsApprovalFileDrop ? " cms-completed-note-modal" : ""
                }`
              : "",
          ]
            .filter(Boolean)
            .join(" ")}
          contentClassName={[
            usesScrollableUploadModal ? "cms-multifile-modal-content" : "",
            supportsApprovalFileDrop && this.state.isDragOver
              ? "cms-modal-drag-over"
              : "",
          ]
            .filter(Boolean)
            .join(" ")}
          //   onHide={() => this.props.parentCallback(this.props.show, false)}
        >
          <Modal.Header
            closeButton={this.props.endButton == true ? "" : true}
            className={
              supportsApprovalFileDrop ? "cms-completed-note-header" : ""
            }
            {...approvalDropHandlers}
          >
            {supportsApprovalFileDrop ? (
              <div className="cms-completed-note-header__content">
                <span className="cms-completed-note-header__icon" aria-hidden="true">
                  <FileText size={18} />
                </span>
                <div className="cms-completed-note-header__text">
                  <h2 className="cms-completed-note-header__title">
                    {this.props.title}
                  </h2>
                  <p className="cms-completed-note-header__subtitle">
                    Share your updates, notes or additional information
                  </p>
                </div>
              </div>
            ) : (
              <div
                className={`text-center col-11 font-f-sans ${
                  isClientNoteModal ? "" : "white"
                }`}
              >
                {this.props.title}
              </div>
            )}
          </Modal.Header>
          <Modal.Body
            className={
              supportsApprovalFileDrop
                ? "cms-completed-note-body"
                : "ml-2 mr-2"
            }
            {...approvalDropHandlers}
          >
            {this.props.type == "edit" ? (
              <form action="" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="form-group col-6">
                    <label className="profile-label">Name:</label>
                    <input
                      name="name"
                      onChange={this.handleChange}
                      className="card-text form-control acc-form col-11"
                      defaultValue={this.props.data["name"]}
                    />
                  </div>
                  <div className="form-group col-6">
                    <label className="profile-label">Email:</label>
                    <input
                      name="email"
                      onChange={this.handleChange}
                      className="card-text form-control acc-form col-11"
                      defaultValue={this.props.data["email"]}
                    />
                  </div>
                  <div className="form-group col-6">
                    <label className="profile-label ">Mobile:</label>
                    <input
                      name="mobile"
                      onChange={this.handleChange}
                      className="card-text form-control acc-form col-11"
                      defaultValue={this.props.data["mobile"]}
                    />
                  </div>
                  <div className="form-group col-6">
                    <label className="profile-label ">Country:</label>
                    <select
                      onChange={this.handleChange}
                      className="form-select acc-form form-select-lg w-lg-90"
                      defaultValue={this.props.data["country"]}
                      aria-label="form-select-lg example"
                      name="country"
                    >
                      <option value="Pakistan">Pakistan</option>
                      <option value="Australia">Australia</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </form>
            ) : (
              ""
            )}
            {this.props.type === "pass" ? (
              <form action="" onSubmit={this.handlePassSubmit}>
                <div className="row">
                  <div className="form-group col-12">
                    <label className="profile-label">Old Password:</label>
                    <input
                      type="password"
                      name="oldPass"
                      onChange={this.handleChange}
                      className="card-text form-control acc-form col-11"
                    />
                    {this.state.oldPassError && (
                      <>
                        <small className="error">
                          {this.state.oldPassError}
                        </small>
                      </>
                    )}
                  </div>
                  <div className="form-group col-12">
                    <label className="profile-label">New Password:</label>
                    <input
                      type="password"
                      name="newPass"
                      onChange={this.handleChange}
                      className="card-text form-control acc-form col-11"
                    />
                    {this.state.newPassError && (
                      <>
                        <small className="error">
                          {this.state.newPassError}
                        </small>
                      </>
                    )}
                  </div>
                  <div className="form-group col-12">
                    <label className="profile-label">
                      Confirm New Password:
                    </label>
                    <input
                      type="password"
                      name="confirmNewPass"
                      onChange={this.handleChange}
                      className="card-text form-control acc-form col-11"
                    />
                    {this.state.confirmNewPassError && (
                      <>
                        <small className="error">
                          {this.state.confirmNewPassError}
                        </small>
                      </>
                    )}
                  </div>
                </div>
              </form>
            ) : this.props.type === "category" ? (
              <form action="" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="form-group col-12">
                    {this.props.textarea &&
                    !this.props.date &&
                    this.props.noteType != false ? (
                      <>
                        <label
                          className={
                            isClientNoteModal
                              ? "cms-note-field-label"
                              : "profile-label"
                          }
                        >
                          Medium
                        </label>
                        <select
                          defaultValue={this.state.email}
                          onChange={this.handleChange}
                          name="email"
                          className={
                            isClientNoteModal
                              ? "form-select cms-note-medium-select w-100 mb-3"
                              : "form-select acc-form w-100 mb-3"
                          }
                        >
                          <option value="">Please select</option>
                          {note_type.map((head) => (
                            <option key={head.value} value={head.value}>
                              {head.title}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : (
                      ""
                    )}

                    {/* As remove the descriotion tags in notes modal */}
                    {/* {this.props.tags && this.props.tags[0] && 
                <>
                <div className='col-lg-6 mb-lg-3 pl-0'>
                <label className="acc-label2 mb-0">Description Tags</label>
                <select className="form-select acc-form form-select-lg w-lg-90" aria-label="form-select-lg example"
                onChange={(e) => this.setState({name:e.target.value})}>
                <option  value=''>Please Select</option>
                {[].concat(this.props.tags).sort((a, b) => a.name > b.name ? 1 : -1).map(value =>
                <option key={value.id} className="light" value={value.description}>{value.name}</option> )}
                </select>
                </div>
                </>} */}

                    {supportsApprovalFileDrop ? (
                      <label className="cms-completed-note-label">
                        <StickyNote size={14} aria-hidden="true" />
                        <span>{this.props.data}</span>
                        <span className="cms-completed-note-required">*</span>
                      </label>
                    ) : (
                      <label
                        className={
                          isClientNoteModal
                            ? "cms-note-field-label"
                            : "profile-label"
                        }
                      >
                        {this.props.data}
                      </label>
                    )}
                    {this.props.textarea && !this.props.date ? (
                      <>
                        {supportsApprovalFileDrop ? (
                          <div className="cms-completed-note-textarea-wrap">
                            <textarea
                              className="cms-completed-note-textarea"
                              placeholder="Write your note here..."
                              name="name"
                              value={this.state.name || ""}
                              onChange={this.handleChange}
                              maxLength={2000}
                              rows={5}
                            />
                            <span className="cms-completed-note-char-count">
                              {(this.state.name || "").length}/2000
                            </span>
                          </div>
                        ) : (
                          <textarea
                            className={
                              isClientNoteModal
                                ? "textarea form-control cms-note-textarea"
                                : "textarea form-control app-form"
                            }
                            placeholder="Write your note here…"
                            name="name"
                            defaultValue={this.state.name}
                            onChange={this.handleChange}
                            rows="4"
                            cols="60"
                          ></textarea>
                        )}

                        {/* Intake selection for Deferred Offer (Education, status 110) */}
                        {this.props.from === "edu" &&
                          (this.props.appid === 110 ||
                            this.props.appid === "110") &&
                          Array.isArray(this.props.intakes) && (
                            <div className="mt-3">
                              <label className="profile-label d-block mb-1">
                                Current Intake:
                              </label>
                              <div className="mb-2">
                                <span className="badge bg-light text-dark border">
                                  {this.props.currentIntakeLabel ||
                                    "Not set on application"}
                                </span>
                              </div>
                              <label className="profile-label d-block mb-1">
                                Select New Intake{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                name="intake_id"
                                className="form-select acc-form"
                                value={this.state.intake_id}
                                onChange={this.handleChange}
                              >
                                <option value="">Please Select</option>
                                {[]
                                  .concat(this.props.intakes)
                                  .sort((a, b) => (a.title > b.title ? 1 : -1))
                                  .map((intake) => (
                                    <option key={intake.id} value={intake.id}>
                                      {intake.title}
                                    </option>
                                  ))}
                              </select>
                              {this.state.intakeError && (
                                <small className="text-danger">
                                  {this.state.intakeError}
                                </small>
                              )}
                            </div>
                          )}

                        {this.props.healthRefund == true ? (
                          <>
                            {/* <div className="row  mt-2">
                              <label
                                className="profile-label col-lg-7"
                                for="myfile"
                              >
                                Have you purchased OSHC?
                              </label>
                              <div className="form-check col-2">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="healthClaim"
                                  id="radio1"
                                  value="1"
                                  onClick={() => {
                                    this.setState({
                                      healthClaim: 1,
                                      oshc_user_confirmed: true,
                                    });
                                  }}
                                  checked={
                                    this.state.healthClaim == 1 ? true : false
                                  }
                                />
                                Yes
                                <label
                                  className="form-check-label"
                                  for="radio1"
                                ></label>
                              </div>
                              <div className="form-check ml-2 col-2">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="healthClaim"
                                  id="radio2"
                                  value="0"
                                  onClick={() => {
                                    this.setState({
                                      healthClaim: 0,
                                      oshc_user_confirmed: false,
                                    });
                                  }}
                                  checked={
                                    this.state.healthClaim == 0 ? true : false
                                  }
                                />
                                No
                                <label
                                  className="form-check-label"
                                  for="radio2"
                                ></label>
                              </div>
                            </div> */}
                            {/* {this.state.healthClaim === 1 ? (
                              <div className="p-2 border">
                                <label
                                  className="profile-label mt-2"
                                  for="myfile"
                                >
                                  Start Date of OSHC
                                </label>
                                <input
                                  type="date"
                                  className="date-input w-lg-90 ml-1"
                                  placeholder="Please Enter"
                                  name="email"
                                  onChange={this.handleChange}
                                />
                                <label
                                  className="profile-label mt-2"
                                  for="myfile"
                                >
                                  End Date of OSHC
                                </label>
                                <input
                                  type="date"
                                  className="date-input w-lg-90 ml-1"
                                  placeholder="Please Enter"
                                  name="mobile"
                                  onChange={this.handleChange}
                                />
                                <label
                                  className="profile-label mt-2"
                                  for="myfile"
                                >
                                  Amount
                                </label>
                                <input
                                  type="text"
                                  className="card-text form-control acc-form col-7"
                                  placeholder="Please Enter"
                                  name="country"
                                  onChange={this.handleChange}
                                />
                                <label
                                  className="profile-label mt-2"
                                  for="myfile"
                                >
                                  Provider:{" "}
                                </label>
                                <select
                                  className="form-select app-form col-7"
                                  name="provider"
                                  onChange={this.handleChange}
                                >
                                  <option value="">Please Select </option>
                                  {healthProviders.map((v, index) => (
                                    <option key={index} className="light">
                                      {v.title}
                                    </option>
                                  ))}
                                </select>
                                <label
                                  className="profile-label mt-2"
                                  for="myfile"
                                >
                                  Oshc Reciept :{" "}
                                </label>
                                <input
                                  type="file"
                                  onChange={this.fileSelectedHandlerOshc}
                                  className="form-control acc-form w-lg-90"
                                  placeholder="Please Enter"
                                />
                                <label
                                  className="profile-label mt-2"
                                  for="myfile"
                                >
                                  Oshc Certificate:{" "}
                                </label>
                                <input
                                  type="file"
                                  onChange={
                                    this.fileSelectedHandlerOshcCertificate
                                  }
                                  className="form-control acc-form w-lg-90"
                                  placeholder="Please Enter"
                                />
                              </div>
                            ) : (
                              ""
                            )} */}
                          </>
                        ) : (
                          ""
                        )}

                        {/* upload docs */}
                        {this.props.uploadDoc1 == true &&
                        this.props.multipleFiles == false &&
                        (this.props.appid != 9 || this.props.appid != "9") ? (
                          <>
                            <label className="profile-label mt-2" for="myfile">
                              {this.props.file1name}
                            </label>
                            <input
                              type="file"
                              onChange={this.fileSelectedHandler}
                              className="form-control acc-form w-lg-90"
                              placeholder="Please Enter"
                            />
                          </>
                        ) : this.props.uploadDoc1 == true &&
                          this.props.multipleFiles == true &&
                          (this.props.appid != 9 || this.props.appid != "9") ? (
                          this.renderApprovalFileUpload()
                        ) : (
                          ""
                        )}
                        {this.props.selectedAppId == 9 &&
                          this.renderCoeFileUpload()}

                        {this.props.uploadDoc2 == true &&
                          this.renderPaymentFileUpload()}
                        {this.props.courses && this.props.courses[0] && (
                          <>
                            {(this.state.courses?.length
                              ? this.state.courses
                              : this.props.courses
                            ).map((v, index) => {
                              return (
                                <div
                                  key={v.id || v.courseid || index}
                                  className="row mb-2 mt-2 border p-2"
                                >
                                  <label className="text-center bold font-f-monst-sans bg-white-smoke size-15 p-1 mb-3 pt-1">
                                    Course{" "}
                                  </label>
                                  <div className="col-lg-6">
                                    <label className="acc-label2 mb-1 size-15">
                                      Course:
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control acc-form w-lg-90"
                                      defaultValue={v.name}
                                      placeholder="Please enter"
                                      onChange={(e) =>
                                        this.handleInputChange(e, index)
                                      }
                                      disabled
                                    />
                                  </div>

                                  <div className="col-lg-6">
                                    <label className="acc-label2 mb-1 size-15">
                                      Total Tuition Fee:
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control acc-form w-lg-90"
                                      value={v.offered_fee ?? ""}
                                      placeholder="Please enter"
                                      name="offered_fee"
                                      onChange={(e) =>
                                        this.handleInputChange(e, index)
                                      }
                                    />
                                  </div>

                                  <div className="col-lg-6">
                                    <label className="acc-label2 mb-1 size-15">
                                      Start Date:
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control acc-form w-lg-90"
                                      value={
                                        v.startdate
                                          ? String(v.startdate).slice(0, 10)
                                          : ""
                                      }
                                      placeholder="Please enter"
                                      name="startdate"
                                      onChange={(e) =>
                                        this.handleInputChange(e, index)
                                      }
                                    />
                                  </div>

                                  <div className="col-lg-6">
                                    <label className="acc-label2 mb-1 size-15">
                                      End Date:
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control acc-form w-lg-90"
                                      value={
                                        v.enddate
                                          ? String(v.enddate).slice(0, 10)
                                          : ""
                                      }
                                      placeholder="Please enter"
                                      name="enddate"
                                      onChange={(e) =>
                                        this.handleInputChange(e, index)
                                      }
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        )}
                      </>
                    ) : this.props.textarea && this.props.from === "mig" ? (
                      <>
                        {/* Info Requested */}
                        <textarea
                          className="textarea form-control app-form"
                          placeholder="Please Enter"
                          name="name"
                          onChange={this.handleChange}
                          rows="4"
                          cols="60"
                        ></textarea>

                        {(this.props.appid === 94 ||
                          this.props.appid === "9") && (
                          <>
                            <div className="form-group col-12 mt-2">
                              <input
                                className="form-check-input"
                                onChange={(e) =>
                                  this.setState({ checkbox: e.target.checked })
                                }
                                type="checkbox"
                              />
                              <label className="form-check-label profile-label">
                                RFI Received
                              </label>
                              {this.state.checkbox === true && (
                                <>
                                  <br />
                                  <label className="form-check-label profile-label ">
                                    Rfi Due Date
                                  </label>
                                  <input
                                    type="date"
                                    onChange={this.handleChange}
                                    name="email"
                                    className="date-input col-12"
                                  />
                                </>
                              )}
                            </div>
                            <div className="form-group col-12 mt-2">
                              <input
                                className="form-check-input"
                                onChange={(e) =>
                                  this.setState({ checkbox2: e.target.checked })
                                }
                                type="checkbox"
                              />
                              <label className="form-check-label profile-label">
                                NJ Received
                              </label>
                              {this.state.checkbox2 === true && (
                                <>
                                  <br />
                                  <label className="form-check-label profile-label ">
                                    NJ Due Date
                                  </label>
                                  <input
                                    type="date"
                                    onChange={this.handleChange}
                                    name="mobile"
                                    className="date-input col-12"
                                  />
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {(this.props.appid === 10 ||
                          this.props.appid === "10") && (
                          <>
                            <div className="form-group col-12 mt-2">
                              <input
                                className="form-check-input"
                                onChange={(e) =>
                                  this.setState({ checkbox: e.target.checked })
                                }
                                type="checkbox"
                              />
                              <label className="form-check-label profile-label ps-1">
                                RFI Submitted
                              </label>
                            </div>
                            <div className="form-group col-12 mt-2">
                              <input
                                className="form-check-input"
                                onChange={(e) =>
                                  this.setState({ checkbox2: e.target.checked })
                                }
                                type="checkbox"
                              />
                              <label className="form-check-label profile-label ps-1">
                                NJ Submitted
                              </label>
                            </div>
                          </>
                        )}
                        {/* when app type no mig then show this */}
                        {this.props.date == true && this.props.from != "mig" ? (
                          <>
                            <label className="mt-2">
                              {this.props.dateText}
                            </label>
                            <input
                              type="date"
                              onChange={this.handleChange}
                              name="email"
                              className="date-input col-12"
                            />
                          </>
                        ) : (
                          ""
                        )}
                        {this.props.date2 == true ? (
                          <>
                            {" "}
                            <label className="mt-2">
                              {this.props.dateText2}
                            </label>
                            <input
                              type="date"
                              onChange={this.handleChange}
                              name="mobile"
                              className="date-input col-12"
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    ) : this.props.textarea && this.props.from === "edu" ? (
                      <>
                        <textarea
                          className="textarea form-control app-form"
                          placeholder="Please Enter"
                          name="name"
                          onChange={this.handleChange}
                          rows="4"
                          cols="60"
                        ></textarea>
                      </>
                    ) : (
                      <>
                        <input
                          type="text"
                          placeholder={
                            this.props.placeholder
                              ? this.props.placeholder
                              : "Please enter"
                          }
                          defaultValue={
                            this.props.defaultValue
                              ? this.props.defaultValue
                              : ""
                          }
                          name="name"
                          onChange={this.handleChange}
                          className="card-text form-control acc-form col-11"
                        />
                        {this.props.smallLabel && (
                          <small className="text-muted pl-lg-1 size-13">
                            {this.props.smallLabel}
                          </small>
                        )}
                      </>
                    )}

                    {this.props.reschedule === true && (
                      <>
                        <div className="form-check pt-4">
                          <input
                            className="form-check-input"
                            checked={this.state.checkbox === true}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              this.setState({
                                checkbox: checked,
                                mobile: checked
                                  ? this.state.mobile ||
                                    getLocalDateInputValue()
                                  : this.state.mobile,
                              });
                            }}
                            type="checkbox"
                          />
                          <label className="form-check-label">
                            Reschedule the Follow up
                          </label>
                          {this.state.checkbox === true ? (
                            <input
                              className="date-input col-12 mt-3"
                              value={
                                typeof this.state.mobile === "string"
                                  ? this.state.mobile
                                  : getLocalDateInputValue()
                              }
                              onChange={this.handleChange}
                              name="mobile"
                              type="date"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}

                    {this.props.reassign === true && (
                      <>
                        <div className="form-check pt-4">
                          <input
                            className="form-check-input"
                            defaultChecked={this.state.checkbox2}
                            onChange={(e) =>
                              this.setState({ checkbox2: e.target.checked })
                            }
                            type="checkbox"
                          />
                          <label className="form-check-label">
                            ReAssign the Follow up
                          </label>
                          {this.state.checkbox2 === true && (
                            <select
                              className="form-select app-form"
                              name="country"
                              value={this.state.country}
                              onChange={this.handleChange}
                            >
                              <option value="0">Assign To </option>
                              {[]
                                .concat(this.props.allUsers)
                                .sort((a, b) => (a.name > b.name ? 1 : -1))
                                .map((v, index) => (
                                  <option
                                    key={index}
                                    className="light"
                                    value={v.id}
                                  >
                                    {v.name}
                                  </option>
                                ))}
                            </select>
                          )}
                        </div>
                      </>
                    )}

                    {this.props.intakeDropdown === true && (
                      <>
                        <br />
                        <div className="row mt-3">
                          <div className="col-6">
                            <select
                              value={this.props.defaultQuarter}
                              onChange={this.handleChange}
                              className="form-select acc-form form-select-lg"
                              name="email"
                            >
                              <option value="">Select Quarter</option>
                              <option>Q1</option>
                              <option>Q2</option>
                              <option>Q3</option>
                              <option>Q4</option>
                            </select>
                          </div>
                          <div className="col-6 pl-4">
                            <select
                              value={this.props.defaultYear}
                              onChange={this.handleChange}
                              className="form-select acc-form form-select-lg"
                              name="mobile"
                            >
                              <option value="">Select Year</option>
                              <option>2020</option>
                              <option>2021</option>
                              <option>2022</option>
                              <option>2023</option>
                              <option>2024</option>
                              <option>2025</option>
                              <option>2026</option>
                              <option>2027</option>
                              <option>2028</option>
                              <option>2029</option>
                            </select>
                          </div>
                        </div>
                      </>
                    )}

                    {this.props.categoryDropdown == true && (
                      <>
                        <br />
                        <label className="profile-label">Category</label>
                        <select
                          onChange={this.handleChange}
                          className="form-select acc-form form-select-lg col-lg-11"
                          name="email"
                          value={this.props.defaultTitleValue}
                        >
                          <option value="">Please Select</option>
                          {education_category.map((head) => (
                            <option key={head.title} value={head.title}>
                              {head.title}
                            </option>
                          ))}
                        </select>
                      </>
                    )}
                  </div>
                  {this.props.dropdown == true && (
                    <>
                      <label className="profile-label">Note For</label>
                      <select
                        onChange={this.handleChange}
                        className="form-select acc-form form-select-lg"
                        name="email"
                        value={this.state.email}
                      >
                        <option value="">Please Select</option>
                        <option value="0">All</option>
                        <option value="1">Super Admin</option>
                        <option value="2">Admin</option>
                        <option value="3">User</option>
                        <option value="4">Accountant</option>
                      </select>
                    </>
                  )}
                </div>

                {this.props.showStatusDate && (
                  <div className="form-group col-12 mt-2">
                    <label className="profile-label">
                      {/* {this.props.from === "edu" &&
                      (this.props.appid === 5 || this.props.appid === "5")
                        ? this.props.dateText || "RFI Due Date"
                        : this.props.dateText || "Status Change Date"} */}
                      Status Change Date
                      <label className="text-danger">*</label>
                    </label>
                    <input
                      type="date"
                      className="form-control acc-form"
                      value={this.state.statusChangeDate}
                      onChange={(e) =>
                        this.setState({
                          statusChangeDate: e.target.value,
                        })
                      }
                      required
                    />
                    {!this.state.statusChangeDate && this.state.submitted && (
                      <small className="error">
                        Status change date is required
                      </small>
                    )}
                  </div>
                )}

                {this.props.clientNote && this.hasFinanceNotePermission() && (
                  <>
                    <div
                      className={
                        isClientNoteModal
                          ? "col-12 cms-note-finance-toggle"
                          : "col-12 my-1 size-15 d-flex align-items-center"
                      }
                    >
                      <input
                        className="form-check-input"
                        name="isFinanceNote"
                        type="checkbox"
                        onChange={(e) =>
                          this.setState({ isFinanceNote: e.target.checked })
                        }
                        checked={this.state.isFinanceNote}
                      />
                      <label className="form-check-label profile-label text-primary fw-semibold">
                        <DollarSign className="h-4 w-4" /> Finance Note
                      </label>
                    </div>
                  </>
                )}

                {this.props.clientNote && (
                  <>
                    <div className="col-12 my-1 size-15">
                      {/* <input
                        className="form-check-input"
                        name="mobile"
                        type="checkbox"
                        onChange={(e) =>
                          this.setState((prevState) => ({
                            mobile: !prevState.mobile, // Toggle the value
                          }))
                        }
                        checked={this.state.mobile ? this.state.mobile : false}
                      />
                      <label className="form-check-label profile-label">
                        Show this note to client portal!
                      </label> */}
                    </div>
                  </>
                )}

                {this.props.clientNote && (
                  <>
                    <div className="col-12 my-1 size-15">
                      {/* <input
                        className="form-check-input"
                        name="processingTasks"
                        type="checkbox"
                        onChange={(e) =>
                          this.setState({ processingTasks: e.target.checked })
                        }
                        checked={this.state.processingTasks}
                      />
                      <label className="form-check-label profile-label">
                        Processing Task
                      </label> */}
                    </div>

                    {this.state.processingTasks && (
                      <div className="processing-tasks-fields mt-3">
                        <div className="form-group mb-3">
                          <label className="profile-label">Due Date:</label>
                          <input
                            type="date"
                            className="form-control acc-form"
                            value={this.state.processingDueDate}
                            onChange={(e) =>
                              this.setState({
                                processingDueDate: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label className="profile-label">Priority:</label>
                          <select
                            className="form-select acc-form"
                            value={this.state.processingPriority}
                            onChange={(e) =>
                              this.setState({
                                processingPriority: e.target.value,
                              })
                            }
                            {...console.log(this.state.processingPriority)}
                            {...console.log(this.state.processingDueDate)}
                          >
                            <option value="High">High</option>
                            <option value="Standard">Standard</option>
                          </select>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </form>
            ) : this.props.type === "refund" ? (
              <form action="" onSubmit={this.handleSubmit}>
                <div className="row justify-content-center">
                  <div className="col-lg-4">
                    <div className="d-flex p-1 ">
                      <h5 className="bold">Paid:</h5>
                      <h5
                        className={`acc-label pl-2 ${
                          this.props.paid > 0.0 ? " active bold " : ""
                        }`}
                      >
                        {this.props.paid}
                      </h5>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="d-flex p-1 ">
                      <h5 className="bold">Remaining:</h5>
                      <h5
                        className={`acc-label pl-2 ${
                          this.props.remaining > 0.0 ? "bold text-danger" : ""
                        }`}
                      >
                        {this.props.remaining}
                      </h5>
                    </div>
                  </div>

                  <div className="col-lg-12 mt-3">
                    {this.props.paid > 0.0 ? (
                      <div>
                        <input
                          type="number"
                          placeholder="Enter Refund Amount"
                          onChange={(e) => this.checkRefund(e.target.value)}
                          className="form-control acc-form col-12"
                          name="name"
                        />
                        {this.state.refundError && (
                          <small className="error">
                            Amount should not be more than paid amount
                          </small>
                        )}
                      </div>
                    ) : (
                      <h5 className="error bold">
                        No amount is paid. You cannot refund amount!
                      </h5>
                    )}
                  </div>
                </div>
              </form>
            ) : this.props.type === "oshc" ? (
              <form action="" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="form-group col-12">
                    <label className="profile-label">Start date of Oshc</label>
                    <input
                      type="date"
                      defaultValue={
                        this.props.data && this.props.data["issuedate"]
                      }
                      className="date-input w-lg-90 ml-1"
                      placeholder="Please Enter"
                      name="name"
                      onChange={this.handleChange}
                      disabled={this.props.onlyView == 1 ? true : false}
                    />
                    <label className="profile-label mt-2">
                      End date of Oshc
                    </label>
                    <input
                      type="date"
                      defaultValue={
                        this.props.data && this.props.data["expirydate"]
                      }
                      className="date-input w-lg-90 ml-1"
                      placeholder="Please Enter"
                      name="email"
                      onChange={this.handleChange}
                      disabled={this.props.onlyView == 1 ? true : false}
                    />
                    <label className="profile-label mt-2" for="myfile">
                      Amount
                    </label>
                    <input
                      type="text"
                      defaultValue={
                        this.props.data && this.props.data["amount"]
                      }
                      className="card-text form-control acc-form col-7"
                      placeholder="Please Enter"
                      name="mobile"
                      onChange={this.handleChange}
                      disabled={
                        this.props.data && this.props.onlyView == 1
                          ? true
                          : false
                      }
                    />
                    <label className="profile-label mt-2" for="myfile">
                      Provider:{" "}
                    </label>
                    <select
                      disabled={
                        this.props.data && this.props.onlyView == 1
                          ? true
                          : false
                      }
                      className="form-select app-form col-7"
                      name="country"
                      value={this.props.data["providername"]}
                      onChange={this.handleChange}
                    >
                      <option value="">Please Select </option>
                      {healthProviders.map((v, index) => (
                        <option key={index} className="light">
                          {v.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </form>
            ) : this.props.type === "attendance" ? (
              <form action="">
                <div className="row">
                  <div className="form-group col-12">
                    <label className="profile-label">Department</label>
                    <select
                      className="form-select app-form"
                      name="name"
                      onChange={this.handleChange}
                      value={this.state.name}
                    >
                      <option value="">Select Department </option>
                      {this.props.department.map((v, index) => (
                        <option key={index++} className="light" value={v.id}>
                          {v.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-12">
                    <label className="profile-label">Employee</label>
                    <select
                      className="form-select app-form"
                      name="email"
                      onChange={this.handleChange}
                      value={this.state.email}
                    >
                      <option value="">Select Employee </option>
                      {[]
                        .concat(this.props.users)
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((v, index) => (
                          <option key={index++} className="light" value={v.id}>
                            {v.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </form>
            ) : this.props.type === "expo" ? (
              <form action="">
                <div className="row">
                  <div className="form-group col-12">
                    <label className="profile-label">{this.props.data}</label>
                    <textarea
                      className="textarea form-control app-form"
                      placeholder="Please Enter"
                      name="name"
                      defaultValue={this.state.name}
                      onChange={this.handleChange}
                      rows="4"
                      cols="60"
                    ></textarea>

                    {this.props.reassign == true && (
                      <div className="form-check pt-4">
                        <input
                          className="form-check-input"
                          defaultChecked={this.state.checkbox2}
                          onChange={(e) =>
                            this.setState({
                              checkbox2: e.target.checked,
                              email: "",
                            })
                          }
                          type="checkbox"
                        />
                        <label className="form-check-label">
                          ReAssign the Follow up
                        </label>
                        {this.state.checkbox2 === true && (
                          <select
                            className="form-select app-form"
                            name="email"
                            value={this.state.email}
                            onChange={this.handleChange}
                          >
                            <option value="">ReAssign To </option>
                            {[]
                              .concat(this.props.allUsers)
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((v, index) => (
                                <option
                                  key={index++}
                                  className="light"
                                  value={v.id}
                                >
                                  {v.name}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>
                    )}
                    {this.props.endButton == true && (
                      <div>
                        <h3 style={{ color: "#0000bd" }}>{this.props.timer}</h3>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            ) : this.props.type === "priority" ? (
              <form action="">
                <div className="row">
                  <div className="form-group col-12">
                    <div className="col-12 mt-2">
                      <label className="profile-label">Select Date: </label>
                      <input
                        type="date"
                        className="date-input col-9 ml-1"
                        placeholder="Please Enter"
                        name="name"
                        defaultValue={this.props.data["priority_date"]}
                        onChange={this.handleChange}
                      />
                    </div>

                    <div className="col-10 d-flex mt-3">
                      <label className="profile-label">Desired Status: </label>
                      <select
                        onChange={this.handleChange}
                        name="mobile"
                        data-live-search="true"
                        value={
                          this.props.data["priority_status"]
                            ? this.props.data["priority_status"]
                            : this.state.mobile
                        }
                        className=" col-12 ml-1"
                      >
                        <option value={0}>Please Select </option>
                        {this.props.status.map((value) => (
                          <option
                            disabled={
                              this.props.selectedStatus == value.value
                                ? true
                                : false
                            }
                            key={value.title}
                            value={value.title}
                          >
                            {value.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            ) : this.props.type === "addTeam" ||
              this.props.type === "editTeam" ? (
              <form action="" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="form-group col-11">
                    <label className="profile-label">Team Name</label>
                    <input
                      type="text"
                      placeholder="Please enter"
                      defaultValue={
                        this.props.type === "editTeam"
                          ? this.props.data["name"]
                          : ""
                      }
                      name="name"
                      onChange={this.handleChange}
                      className="card-text form-control acc-form col-11"
                    />
                  </div>
                  <div className="form-group row col-11">
                    <label className="font-f-monst-sans bold pt-2">
                      Notification Access
                    </label>
                    <div className="col-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          name="value1"
                          type="checkbox"
                          onChange={(e) =>
                            this.setState({ value1: e.target.checked })
                          }
                          defaultChecked={
                            this.props.type === "editTeam"
                              ? this.props.data["general"]
                              : ""
                          }
                        />
                        <label className="form-check-label">General</label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          name="value2"
                          type="checkbox"
                          onChange={(e) =>
                            this.setState({ value2: e.target.checked })
                          }
                          defaultChecked={
                            this.props.type === "editTeam"
                              ? this.props.data["mig"]
                              : ""
                          }
                        />
                        <label className="form-check-label">Migration</label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          name="value3"
                          type="checkbox"
                          onChange={(e) =>
                            this.setState({ value3: e.target.checked })
                          }
                          defaultChecked={
                            this.props.type === "editTeam"
                              ? this.props.data["edu"]
                              : ""
                          }
                        />
                        <label className="form-check-label">Education</label>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          name="value4"
                          type="checkbox"
                          onChange={(e) =>
                            this.setState({ value4: e.target.checked })
                          }
                          defaultChecked={
                            this.props.type === "editTeam"
                              ? this.props.data["marketing"]
                              : ""
                          }
                        />
                        <label className="form-check-label">Marketing</label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          name="value5"
                          type="checkbox"
                          onChange={(e) =>
                            this.setState({ value5: e.target.checked })
                          }
                          defaultChecked={
                            this.props.type === "editTeam"
                              ? this.props.data["accounts"]
                              : ""
                          }
                        />
                        <label className="form-check-label">Accounts</label>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          name="value6"
                          type="checkbox"
                          onChange={(e) =>
                            this.setState({ value6: e.target.checked })
                          }
                          defaultChecked={
                            this.props.type === "editTeam"
                              ? this.props.data["providers"]
                              : ""
                          }
                        />
                        <label className="form-check-label">Providers</label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          name="value7"
                          type="checkbox"
                          onChange={(e) =>
                            this.setState({ value7: e.target.checked })
                          }
                          defaultChecked={
                            this.props.type === "editTeam"
                              ? this.props.data["clients"]
                              : ""
                          }
                        />
                        <label className="form-check-label">Clients</label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            ) : this.props.type === "assignM" ? (
              <form action="" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="form-group col-11">
                    <label className="profile-label">Select Teams:</label>
                    <select
                      onChange={this.handleChange}
                      className="form-select acc-form form-select-lg"
                      name="value1"
                    >
                      <option value="">Please Select</option>
                      {[]
                        .concat(this.props.data)
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((head) => (
                          <option key={head.id} value={head.id}>
                            {head.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  {this.state.value1 && (
                    <div className="form-group col-11">
                      <label className="profile-label">Select Member:</label>
                      <select
                        onChange={this.handleChange}
                        className="form-select acc-form form-select-lg"
                        name="value2"
                      >
                        <option value="">Please Select</option>
                        {[]
                          .concat(this.props.data1)
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((head) => (
                            <option key={head.id} value={head.id}>
                              {head.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>
              </form>
            ) : this.props.type === "assignUserToGroup" ? (
              <form action="" onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="form-group col-11">
                    <label className="profile-label">Select Group:</label>
                    <select
                      onChange={this.handleGroupChange}
                      className="form-select acc-form form-select-lg"
                      name="value1"
                    >
                      <option value="">Please Select</option>
                      {[]
                        .concat(this.props.data)
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((head) => (
                          <option key={head.id} value={head.id}>
                            {head.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  {this.state.value1 && (
                    <Multiselect
                      options={this.props.data1}
                      className="form-select app-form multi col-11"
                      placeholder={"Group"}
                      displayValue="label"
                      onSelect={this.onUsersSelect}
                      onRemove={this.onUsersRemove}
                      showCheckbox={true}
                      disablePreSelectedValues={false}
                      hidePlaceholder={false}
                      selectedValues={this.state.tags}
                    />
                  )}
                </div>
              </form>
            ) : this.props.type === "counseling" ? (
              <form>
                <div className="row">
                  <div className="form-group col-12">
                    <label className="profile-label">Nationality*</label>
                    <select
                      onChange={this.handleChange}
                      className="form-select acc-form form-select-lg"
                      name="value1"
                    >
                      <option value="">Please Select</option>
                      {countries_code.map((head) => (
                        <option key={head.country} value={head.value}>
                          {head.country}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group col-12 mt-2">
                    <label className="profile-label">
                      Country of Residence (Onshore Students only)
                    </label>
                    <select
                      onChange={this.handleChange}
                      className="form-select acc-form form-select-lg"
                      name="value2"
                    >
                      <option value="">Please Select</option>
                      <option value="australia">Australia</option>
                      <option value="canada">Canada</option>
                      <option value="uk">United Kingdom</option>
                    </select>
                  </div>
                </div>
              </form>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              supportsApprovalFileDrop ? "cms-completed-note-footer" : ""
            }
            {...approvalDropHandlers}
          >
            {this.props.endButton == true ? (
              ""
            ) : (
              <Button
                className={
                  supportsApprovalFileDrop
                    ? "btn cms-completed-note-btn-cancel"
                    : "btn btn-danger"
                }
                onClick={() => this.handleModal()}
              >
                Cancel
              </Button>
            )}
            {this.props.submitBtnText ? (
              <Button className="btn btn-success" onClick={this.handleProceed}>
                {this.props.submitBtnText}
              </Button>
            ) : (
              <Button
                className={
                  supportsApprovalFileDrop
                    ? "btn cms-completed-note-btn-submit"
                    : "btn btn-success"
                }
                onClick={
                  this.props.type == "category" &&
                  this.props.from == "mig" &&
                  this.props.appid == 100 &&
                  this.props.allowApproval == true
                    ? this.handleApprovalSubmit
                    : this.props.type == "category" &&
                        this.props.from == "edu" &&
                        this.props.appid == 100 &&
                        this.props.allowApproval == true
                      ? this.handleEduApprovalSubmit
                      : this.props.type == "edit"
                        ? this.handleSubmit
                        : this.props.type == "addTeam" ||
                            this.props.type == "assignM" ||
                            this.props.type == "editTeam"
                          ? this.handleTeamSubmit
                          : this.props.type == "category" ||
                              this.props.type == "refund" ||
                              this.props.type == "oshc" ||
                              this.props.type == "priority" ||
                              this.props.type == "attendance" ||
                              this.props.type == "expo"
                            ? this.handleSubmit
                            : this.props.type == "assignUserToGroup"
                              ? this.handleAssignUserSubmit
                              : this.handlePassSubmit
                }
              >
                {this.props.endButton == true
                  ? "End Consultation"
                  : isClientNoteModal
                    ? "Add Note"
                    : this.props.type === "oshc" && this.props.onlyView == 0
                      ? "Apply Refund"
                      : this.props.type === "oshc" && this.props.onlyView == 1
                        ? "Undo Applied Refund"
                        : "Update"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default Modals;
